var _path;
import * as React from "react";
function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 36a4 4 0 003.998-4h-7.996A4 4 0 0020 36zm13.462-9.357c-1.208-1.297-3.467-3.25-3.467-9.643 0-4.856-3.405-8.744-7.996-9.697V6A2 2 0 1018 6v1.303c-4.591.953-7.996 4.84-7.996 9.697 0 6.394-2.26 8.346-3.467 9.643A1.953 1.953 0 006 28c.007 1.025.811 2 2.006 2h23.988c1.195 0 2-.975 2.006-2a1.951 1.951 0 00-.538-1.357z"
  })));
}
export default SvgNotification;